import { Popover } from "components";
import type { PopoverProps } from "components/Popover";
import type { ReactStoryblokComponent } from "types/storyblok";

export const PopoverAdapter = ({
  blok: { content, backgroundColor, color, iconColor },
  sbEditable,
}: ReactStoryblokComponent<PopoverProps>) => (
  <Popover
    content={content}
    sbEditable={sbEditable}
    backgroundColor={backgroundColor}
    color={color}
    iconColor={iconColor}
  />
);
